import { useMemo } from 'react'
import useHandleResponseAPI from 'hooks/useHandleResponseAPI'
import { useMutation } from 'react-query'
import { login as loginFetch, LoginParams } from 'services/auth.service'

function useLogin(onSuccess?: (data: any) => void) {
  const { mutate, error, isLoading } = useMutation(
    ({ email, password }: LoginParams) => loginFetch({ email, password }),
    {
      onSuccess: (result) => {
        onSuccess?.(result)
      },
    },
  )

  const errMsg = useMemo(() => {
    if (error) return (error as any)?.response?.data?.res_desc
    return ''
  }, [error])

  useHandleResponseAPI({
    isLoading: isLoading,
    errMsg: errMsg,
  })

  return {
    login: mutate,
  }
}

export default useLogin
